import React, { useState, useEffect, useContext } from 'react';
import {Bell, CheckCheck, Trash2, Filter, Search, X,Eye, ChevronLeft, ChevronRight,AlertTriangle, MessageSquare, Calendar, DollarSign, Star
} from 'lucide-react';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import '../../../assests/css/admin/NotificationSystem.css';
import axios from 'axios';
import { AppContext } from '../../../context/Appcontext';
import Swal from 'sweetalert2';

const NotificationSystem = () => {

const { baseUrl, authToken, loggedInAdmin } = useContext(AppContext);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [isRead, setIsRead] = useState(false);
  const [actions, setActions] = useState('');

  // ── Extra zaroori states ──
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [activeFilter, setActiveFilter] = useState('all'); // sirf UI highlight kay liye
  const [searchQuery, setSearchQuery] = useState('');

  // ── Filter options list ──
  const filterOptions = [
    { value: 'all',     label: 'All' },
    // { value: 'unread',  label: 'Unread' },
    // { value: 'read',    label: 'Read' },
    // { value: 'info',    label: 'Info' },
    // { value: 'success', label: 'Success' },
    // { value: 'warning', label: 'Warning' },
    // { value: 'alert',   label: 'Alert' },
  ];

  const viewAllNotification = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("ngadmin_id", loggedInAdmin?.id);
    axios.post(`${baseUrl}/admin/notification/viewAllNotification`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
        "Content-Type" : "multipart/form-data"
      }
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          const updatedNotifications = response.data.notifications.map((item) => {
            let icon = <Bell size={16} />;
            let color = "#3b82f6";

            if (item.category === "booking") {
              icon = <Calendar size={16} />;
              color = "#3b82f6";
            }
            else if (item.category === "payment") {
              icon = <DollarSign size={16} />;
              color = "#10b981";
            }
            else if (item.category === "warning") {
              icon = <AlertTriangle size={16} />;
              color = "#dc2626";
            }
            else if (item.category === "message") {
              icon = <MessageSquare size={16} />;
              color = "#8b5cf6";
            }
            else if (item.category === "rating") {
              icon = <Star size={16} />;
              color = "#f59e0b";
            }

            return {
              ...item,
              icon,
              color
            };
          });

          setNotifications(updatedNotifications);
          setLoading(false);
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
          setLoading(false);
        }
         setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const markAsRead = (notif) => {
    const formData = new FormData();
    formData.append('id', notif.id);
    axios.post(`${baseUrl}/admin/notification/markAsRead`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        console.log("response called", response.data);
        if (response.data.success == true) {
          setNotifications(prev =>
            prev.map(n => n.id === notif.id ? { ...n, isRead: true } : n)
          );
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const markAllAsRead = () => {
    const formData = new FormData();
    formData.append("ngadmin_id", loggedInAdmin?.id);
    axios.post(`${baseUrl}/admin/notification/markAllAsRead`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
        "Content-Type" : "multipart/form-data"
      }
    })
      .then((response) => {
        console.log("response called", response.data);
        if (response.data.success == true) {
          // ── Sab notifications ki isRead true karo ──
          // setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
          viewAllNotification();
          Swal.fire({
            icon : 'success', 
            title : 'Done', 
            text : 'All Notification Marked as Read', 
            confirmButtonText : 'Okay'
          })
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteNotification = (notif) => {
    console.log("**********", notifications);
    const formdata = new FormData();
    formdata.append("id", notif.id);
    axios.post(`${baseUrl}/admin/notification/deleteNotification`, formdata, {
      headers: {
        "Authorization": `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
        viewAllNotification();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewAllNotification();
  }, []);

  return (
    <Adminmasterlayout>
      <div className="adm-notif-page">
        <div className="adm-notif-page__container">
          <div className="adm-notif-page__header">
            <div className="adm-notif-page__header-content">
              <div className="adm-notif-page__icon">
                <Bell size={32} />
              </div>
              <div>
                <h1 className="adm-notif-page__title">Notifications</h1>
                <p className="adm-notif-page__subtitle">
                  Manage all your notifications in one place
                </p>
              </div>
            </div>

            <div className="adm-notif-page__header-actions">
              <button
                className="adm-notif-page__action-btn adm-notif-page__action-btn--secondary"
                onClick={markAllAsRead}
              >
                <CheckCheck size={18} />
                <span>Mark All Read</span>
              </button>
              <button
                className="adm-notif-page__action-btn adm-notif-page__action-btn--danger"
              >
                <Trash2 size={18} />
                <span>Clear All</span>
              </button>
            </div>
          </div>

          <div className="adm-notif-page__controls">
            <div className="adm-notif-page__filters">
              <Filter size={18} />
              <div className="adm-notif-page__filter-list">
                {filterOptions.map(option => (
                  <button
                    key={option.value}
                    className={`adm-notif-page__filter-btn ${
                      activeFilter === option.value
                        ? 'adm-notif-page__filter-btn--active'
                        : ''
                    }`}
                    onClick={() => setActiveFilter(option.value)}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="adm-notif-page__search">
              <Search size={18} />
              <input
                type="text"
                placeholder="Search notifications..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="adm-notif-page__search-input"
              />
              {searchQuery && (
                <button
                  className="adm-notif-page__search-clear"
                  onClick={() => setSearchQuery('')}
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>

          <div className="adm-notif-page__table-wrapper">

            {/* Loading state */}
            {loading ? (
              <div className="adm-notif-page__empty">
                <span className="spinner-border spinner-border" role="status" />
                <p className="mt-3">Loading Notifications...</p>
              </div>

            ) : notifications.length === 0 ? (
              <div className="adm-notif-page__empty">
                <Bell size={64} />
                <h3>No notifications found</h3>
                <p>You're all caught up!</p>
              </div>

            ) : (
              <div className="adm-notif-page__table-container">
                <table className="adm-notif-page__table">
                  <thead className="adm-notif-page__table-head">
                    <tr>
                      <th className="adm-notif-page__table-th">Title</th>
                      <th className="adm-notif-page__table-th">Message</th>
                      <th className="adm-notif-page__table-th">Status</th>
                      <th className="adm-notif-page__table-th">Actions</th>
                    </tr>
                  </thead>

                  {/* Rows */}
                  <tbody className="adm-notif-page__table-body">
                    {notifications.map((notif) => (
                      <tr
                        key={notif.id}
                        className={`adm-notif-page__table-row ${
                          !notif.isRead ? 'adm-notif-page__table-row--unread' : ''
                        }`}
                      >
                        <td className="adm-notif-page__table-td adm-notif-page__table-td--title">
                          {notif.title}
                        </td>

                        <td className="adm-notif-page__table-td adm-notif-page__table-td--message">
                          {notif.message || notif.description}
                        </td>

                        <td className="adm-notif-page__table-td">
                          {notif.isRead ? (
                            <span className="adm-notif-page__status-badge adm-notif-page__status-badge--read">
                              Read
                            </span>
                          ) : (
                            <span className="adm-notif-page__status-badge adm-notif-page__status-badge--unread">
                              Unread
                            </span>
                          )}
                        </td>

                        <td className="adm-notif-page__table-td">
                          <div className="adm-notif-page__table-actions">
                            {!notif.isRead && (
                              <button
                                className="adm-notif-page__table-action-btn adm-notif-page__table-action-btn--read"
                                title="Mark as read"
                                onClick={() => markAsRead(notif)}
                              >
                                <CheckCheck size={15} />
                              </button>
                            )}
                            <button
                              className="adm-notif-page__table-action-btn adm-notif-page__table-action-btn--view"
                              title="View Details"
                            >
                              <Eye size={15} />
                            </button>

                            {/* Delete */}
                            <button
                              className="adm-notif-page__table-action-btn adm-notif-page__table-action-btn--delete"
                              title="Delete"
                              onClick={() => deleteNotification(notif)}
                            >
                              <Trash2 size={15} />
                            </button>

                          </div>
                        </td>

                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            )}
          </div>

        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default NotificationSystem;